import { Input, EventEmitter, Output } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";

export abstract class FieldBase {

    /** Event that is emitted when the value changes. */
    @Output('change') change: EventEmitter<any> = new EventEmitter();

    /** formGroup is required. */
    @Input() formGroup: FormGroup;
    /** formControl is required. */
    @Input() control: FormControl;
    /** name is required. */
    @Input() name: string;

    
    // Optional parameters.
    
    /** By default, the label is undefined and not displayed. */
    @Input() label: string = undefined;
    /** By default, placeholder is undefined and it is not displayed. */
    @Input() placeholder: string;
    /** By default, readonly is false and the input is editable. */
    @Input() readonly: boolean = false;
    /** By default, required is false. */
    @Input() required: boolean = false;

    /** By default, displayRequired is undefined and not evaluated. */
    @Input() displayRequired: boolean;
    /** By default, crossValidation is undefined and is not applied. */
    @Input() crossValidation: string;


    // Default CSS classes.

    /** By default, containerClass is form-group. */
    @Input() containerClass: string = "form-group";
    /** By default, containerRequiredClass is form-required. */
    @Input() containerRequiredClass: string = "form-required";
    /** By default, containerErrorClass is form-error. */
    @Input() containerErrorClass: string = "form-error";
    /** Default class of the element */
    @Input() inputClass: string = this.setDefaultInputClass();

    protected abstract setDefaultInputClass(): string;

    onChange($event: Event) {
        this.change.emit(null);
        $event.stopPropagation();
    }

    getContainerClasses(): string[] {
        let classes = [this.containerClass];
        if (this.displayRequired || (this.displayRequired === undefined && this.required)) {
            classes.push(this.containerRequiredClass)
        }
        if ((this.control.dirty || this.control.touched)) {
            if (this.control.invalid) {
                classes.push(this.containerErrorClass);
            } else if (this.crossValidation && this.formGroup && this.formGroup.errors && this.formGroup.errors[this.crossValidation]) {
                classes.push(this.containerErrorClass);
            }
        }
        return classes;
    }
}
